(function() {
  angular.module('cfn').factory('Stockyard', Stockyard);

  Stockyard.$inject = ['dataSource.factory'];
  function Stockyard(dataSource) {
    return dataSource('stockyard').getRestService();
  }
})();
